module.exports = __webpack_public_path__ + "static/media/resource-link.b8b6dbf3.svg";